
export const apiHost = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : '';

export const siteHost = process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080'
    : 'http://kpi.ijixiao.com';

export const apiPrefix = `${apiHost}/api/v1`;
export const fileHost = `${apiHost}/files`; // 上传文件服务地址

export default {
    common: {
        verCodeImg: apiPrefix + '/common/ver-code-img', // 获取验证码图片
        uploadTTL: apiPrefix + '/common/upload-ttl', // 临时文件上传路径
        upload: apiPrefix + '/common/upload', // 文件上传路径
        delUpload: apiPrefix + '/common/del-upload', // 删除上传的临时文件
        delFile: apiPrefix + '/common/del-file', // 根据文件id删除上传的文件
        delFileByNamePrefix: apiPrefix + '/common/files-manager/',
        commitFiles: apiPrefix + '/common/commit-files',
        getAuthorInfo: apiPrefix + '/common/get-author-info', // 获取当前登录用户信息
        createId: apiPrefix + '/common/create-id', // 生成唯一id
        randomStr: apiPrefix + '/common/random-str', // 生成随机字符串
        notice: {
            sendLoginVerifyCode: apiPrefix + '/common/notice/send-login-verify-code', // 发送登录验证码
            sendRegisterVerifyCode: apiPrefix + '/common/notice/send-register-verify-code', // 发送注册验证码
            sendSmsVerifyCode: apiPrefix + '/common/notice/send-sms-verify-code', // 发送短信验证码
            sendEmailVerifyCode: apiPrefix + '/common/notice/send-email-verify-code', // 发送邮件验证码
        },
        uDictionary: {
            saveCate: apiPrefix + '/common/u-dictionary/save-cate', // 保存字典分类
            removeCate: apiPrefix + '/common/u-dictionary/remove-cate', // 删除字典分类
            getCateList: apiPrefix + '/common/u-dictionary/get-cate-list', // 获取所有字典分类
            getCateDetail: apiPrefix + '/common/u-dictionary/get-cate-detail', // 获取分类详情

            save: apiPrefix + '/common/u-dictionary/save', // 保存用户字典
            remove: apiPrefix + '/common/u-dictionary/save', // 删除用户字典
            getDetail: apiPrefix + '/common/u-dictionary/get-detail', // 获取字典详情
            getList: apiPrefix + '/common/u-dictionary/get-list', // 获取分类的字典列表
            getAll: apiPrefix + '/common/u-dictionary/get-all', // 获取用户所有字典项列表
        },
    },
    config: {
        getCateList: apiPrefix + '/config/get-cate-list',
        getMetaList: apiPrefix + '/config/get-meta-list',
        saveMany: apiPrefix + '/config/save-many',
        getValue: apiPrefix + '/config/get',
        saveValue: apiPrefix + '/config/save',
        getUserValue: apiPrefix + '/config/get-user-config',
        saveUserValue: apiPrefix + '/config/save-user-config',
        saveUserMany: apiPrefix + '/config/save-user-config-many',
        getMany: apiPrefix + '/config/get-many',
        getAll: apiPrefix + '/config/get-all',
    },
    dictionary: {
        save: apiPrefix + '/dictionary/save',
        remove: apiPrefix + '/dictionary/remove',
        getDetail: apiPrefix + '/dictionary/get-detail',
        getList: apiPrefix + '/dictionary/get-list',
        getCategories: apiPrefix + '/dictionary/get-categories',
        setStatus: apiPrefix + '/dictionary/set-status',
    },
    sysApi: {
        getCateList: apiPrefix + '/sys-api/cate-list',
        getGroupList: apiPrefix + '/sys-api/group-list',
        getList: apiPrefix + '/sys-api/list',
    },
    role: {
        getList: apiPrefix + '/role/get-list',
        save: apiPrefix + '/role/save',
        remove: apiPrefix + '/role/remove',
        getDetail: apiPrefix + '/role/get-detail',
    },
    roles: {
        grantRoles: apiPrefix + '/roles/grant-roles',
        cancelRoles: apiPrefix + '/roles/cancel-roles',
        getUserRoles: apiPrefix + '/roles/get-user-roles',
    },
    perms: {
        setPerm: apiPrefix + '/perms/set-perm',
        setPermBatch: apiPrefix + '/perms/batch-set-perm',
        delPerm: apiPrefix + '/perms/del-perm',
        getRolePerms: apiPrefix + '/perms/get-role-perms',
        getRolePermsTree: apiPrefix + '/perms/get-role-perms-tree',
        getUserPerms: apiPrefix + '/perms/get-user-perms',
    },
    admin: {
        adminLoginOptions: apiPrefix + '/admin-login-options', // 获取登录选项
        adminLogin: apiPrefix + '/admin-login',
        getPage: apiPrefix + '/admin/get-page',
        save: apiPrefix + '/admin/save',
        remove: apiPrefix + '/admin/remove',
        getDetail: apiPrefix + '/admin/get-detail',
        changeUserPwd: apiPrefix + '/admin/change-user-pwd',
        changeSelfPwd: apiPrefix + '/admin/change-self-pwd',
        toggleUserLocked: apiPrefix + '/admin/toggle-user-locked',
        getList: apiPrefix + '/admin/get-list',
        validPassword: apiPrefix + '/admin/valid-password',
        nameExists: apiPrefix + '/admin/name-exists',
    },
    personal: {
        getStatistics: apiPrefix + '/personal/get-statistics', // 获取个人中心统计数据
    },
    user: {
        getRegisterOptions: apiPrefix + '/register-options',
        register: apiPrefix + '/register', // 用户注册
        resetPassword: apiPrefix + '/reset-password', // 用户重置密码
        getLoginOptions: apiPrefix + '/login-options',
        login: apiPrefix + '/login',
        verifyCodeLogin: apiPrefix + '/verify-code-login',
        save: apiPrefix + '/user/save',
        remove: apiPrefix + '/user/remove',
        getDetail: apiPrefix + '/user/get-detail',
        setPwd: apiPrefix + '/user/set-pwd',
        setSelfPwd: apiPrefix + '/user/set-self-pwd',
        currentUser: apiPrefix + '/user/current-user',
        getPage: apiPrefix + '/user/get-page',
        setState: apiPrefix + '/user/set-state',
        getUsers: apiPrefix + '/user/get-users',
        getUsernames: apiPrefix + '/user/get-user-names', // 根据id获取用户名称
        verifyPassword: apiPrefix + '/user/verify-password',
        uploadCurrentAvatar: apiPrefix + '/user/upload-current-avatar', // 上传当前用户头像
        setCurrentMobile: apiPrefix + '/user/set-current-mobile', // 设置当前用户的手机号
        setCurrentEmail: apiPrefix + '/user/set-current-email', // 设置当前用户的邮箱
        updateCurrentInfo: apiPrefix + '/user/update-current-info', // 更新当前用户的基本信息
        getMySecurity: apiPrefix + '/user/get-my-security', // 获取当前账号安全配置
        setMySecurity: apiPrefix + '/user/set-my-security', // 设置当前账号安全配置
        getUserSecurity: apiPrefix + '/user/get-user-security', // 获取用户安全配置
    },
    userSignLog: {
        getPage: apiPrefix + '/user-sign-logs/get-page',
        clean: apiPrefix + '/user-sign-logs/clean',
    },
    industry: {
        save: apiPrefix + '/industry/save',
        remove: apiPrefix + '/industry/remove',
        getDetail: apiPrefix + '/industry/get-detail',
        getPage: apiPrefix + '/industry/get-page',
        getTree: apiPrefix + '/industry/get-tree',
    },
    org: {
        save: apiPrefix + '/org/save',
        remove: apiPrefix + '/org/remove',
        removeMyOrg: apiPrefix + '/org/remove-my-org',
        getDetail: apiPrefix + '/org/get-detail',
        getPage: apiPrefix + '/org/get-page',
        getListByIds: apiPrefix + '/org/get-list-by-ids',
        getUserOrgPage: apiPrefix + '/org/get-user-org-page',
        addUser: apiPrefix + '/org/add-user',
        updateUser: apiPrefix + '/org/update-user', // 更新用户在机构中的角色
        addUsers: apiPrefix + '/org/add-users',
        removeUser: apiPrefix + '/org/remove-user',
        getOrgUserPage: apiPrefix + '/org/get-org-user-page',
        getMyOrgUserPage: apiPrefix + '/org/get-my-org-user-page',
        saveMyOrg: apiPrefix + '/org/save-my-org', // 保存当前用户的机构信息
        addMySubOrg: apiPrefix + '/org/add-my-sub-org', // 添加下级机构及账号
        getMyOrgList: apiPrefix + '/org/get-my-org-list', // 获取当前用户所在的机构列表
        getMyOrgPage: apiPrefix + '/org/get-my-org-page', // 获取当前用户所在的机构列表
        orgLogin: apiPrefix + '/org/org-login', // 登录企业中心
        orgLogout: apiPrefix + '/org/org-logout', // 退出企业中心
        prepareAddSearchUsers: apiPrefix + '/org/prepare-add-search-users', // 准备添加用户到企业搜索
        myOrgAddUser: apiPrefix + '/org/my-org-add-user', // 添加用户到当前机构
        myOrgRemoveUser: apiPrefix + '/org/my-org-remove-user', // 从当前机构删除用户
        myOrgSearchUser: apiPrefix + '/org/my-org-search-user', // 搜索当前机构用户
        setMyOrgSecurity: apiPrefix + '/org/set-my-org-security', // 设置当前机构安全配置
        getMyOrgSecurity: apiPrefix + '/org/get-my-org-security', // 获取当前机构安全配置
        getOrgSecurity: apiPrefix + '/org/get-org-security', // 获取组织机构安全配置
    },
    orgGroup: {
        addOrg: apiPrefix + '/org-group/add-org',
        joinOrg: apiPrefix + '/org-group/join-org',
        getChildList: apiPrefix + '/org-group/get-child-list',
        getChildTree: apiPrefix + '/org-group/get-child-tree',
        getParentList: apiPrefix + '/org-group/get-parent-list',
        removeChild: apiPrefix + '/org-group/remove-child',
    },
    orgPartner: {
        myOrgAddPartner: apiPrefix + '/org-partner/my-org-add-partner', // 添加合作伙伴到当前机构
        myOrgRemovePartner: apiPrefix + '/org-partner/my-org-remove-partner', // 添加合作伙伴到当前机构
        myOrgGetPartnerList: apiPrefix + '/org-partner/my-org-get-partner-list', // 获取当前机构合作伙伴列表
        myOrgGetPartnerPage: apiPrefix + '/org-partner/my-org-get-partner-page', // 分页获取当前机构合作伙伴列表
        myOrgSearchPrePartnerList: apiPrefix + '/org-partner/my-org-search-pre-partner-list', // 当前机构检索预备合作伙伴列表
    },
    myOrgDep: {
        save: apiPrefix + '/my-org-dep/save', // 保存部门
        remove: apiPrefix + '/my-org-dep/remove', // 删除部门
        getDetail: apiPrefix + '/my-org-dep/get-detail',
        getList: apiPrefix + '/my-org-dep/get-list',
        getPage: apiPrefix + '/my-org-dep/get-page',
    },
    myOrgDepUser: {
        addUser: apiPrefix + '/my-org-dep-user/add-user',
        removeUser: apiPrefix + '/my-org-dep-user/remove-user',
        getDepUserList: apiPrefix + '/my-org-dep-user/get-dep-user-list',
        getDepUserPage: apiPrefix + '/my-org-dep-user/get-dep-user-page',
        getOrgUserDep: apiPrefix + '/my-org-dep-user/get-org-user-dep',
    },
    kpi: {
        personal: {
            // 个人中心，绩效指标相关数据统计接口
            kpiStatistics: apiPrefix + '/kpi/personal/kpi-statistics',
        },
        kpi: {
            save: apiPrefix + '/kpi/kpi/save',
            remove: apiPrefix + '/kpi/kpi/remove',
            removeFile: apiPrefix + '/kpi/kpi/remove-file',
            getDetail: apiPrefix + '/kpi/kpi/get-detail',
            getPage: apiPrefix + '/kpi/kpi/get-page',
            searchPage: apiPrefix + '/kpi/kpi/search-page', // 搜索指标库
            togglePublish: apiPrefix + '/kpi/kpi/toggle-publish', // 发布/取消发布指标库
        },
        kpiItem: {
            getTable: apiPrefix + '/kpi/kpi-item/get-table',
            getDetail: apiPrefix + '/kpi/kpi-item/get-detail',
            save: apiPrefix + '/kpi/kpi-item/save',
            remove: apiPrefix + '/kpi/kpi-item/remove',
            getList: apiPrefix + '/kpi/kpi-item/get-list',
            getTree: apiPrefix + '/kpi/kpi-item/get-tree',
        },
        kpiStorage: {
            create: apiPrefix + '/kpi/kpi-storage/create',
            saveContent: apiPrefix + '/kpi/kpi-storage/save-content',
            saveItem: apiPrefix + '/kpi/kpi-storage/save-item',
            removeItem: apiPrefix + '/kpi/kpi-storage/remove-item',
            getItemDetail: apiPrefix + '/kpi/kpi-storage/get-item-detail',
            getTableData: apiPrefix + '/kpi/kpi-storage/get-table-data',
            getStoreInfo: apiPrefix + '/kpi/kpi-storage/get-store-info',
            remove: apiPrefix + '/kpi/kpi-storage/remove',
        },
        kpiAudit: {
            submit: apiPrefix + '/kpi/kpi-audit/submit', // 提交指标库审核申请
            auditKpi: apiPrefix + '/kpi/kpi-audit/audit-kpi', // 审核指标库
            cancelAudit: apiPrefix + '/kpi/kpi-audit/cancel-audit', // 指标库取消审核
            getAuditLogs: apiPrefix + '/kpi/kpi-audit/get-audit-logs', // 获取审核日志
            getCurrentTaskCount: apiPrefix + '/kpi/kpi-audit/get-current-task-count', // 获取当前用户未完成的审核任务数量
            getCurrentTasks: apiPrefix + '/kpi/kpi-audit/get-current-tasks', // 获取当前用户指标库审核任务列表
        },
        depCate: {
            save: apiPrefix + '/kpi/dep-cate/save',
            remove: apiPrefix + '/kpi/dep-cate/remove',
            getDetail: apiPrefix + '/kpi/dep-cate/get-detail',
            getPage: apiPrefix + '/kpi/dep-cate/get-page',
            getList: apiPrefix + '/kpi/dep-cate/get-list',
        },
        dep: {
            save: apiPrefix + '/dep/save',
            remove: apiPrefix + '/dep/remove',
            getDetail: apiPrefix + '/dep/get-detail',
            getPage: apiPrefix + '/dep/get-page',
            getOrgDepPage: apiPrefix + '/dep/get-dep-page',
            getUserDepPage: apiPrefix + '/dep/user/get-dep-page',
            depAddUser: apiPrefix + '/dep/dep/dep-add-user',
            depRemoveUser: apiPrefix + '/dep/dep/dep-remove-user',
        },
        projKpi: {
            getDraftProjKpi: apiPrefix + '/kpi/proj-kpi/get-draft-kpi', // 获取当前用户未完成的草稿项目绩效指标表id
            create: apiPrefix + '/kpi/proj-kpi/create',
            save: apiPrefix + '/kpi/proj-kpi/save',
            remove: apiPrefix + '/kpi/proj-kpi/remove',
            getDetail: apiPrefix + '/kpi/proj-kpi/get-detail',
            createFromTpl: apiPrefix + '/kpi/proj-kpi/create-from-tpl',
            getPage: apiPrefix + '/kpi/proj-kpi/get-page',
            getMyProjKpiPage: apiPrefix + '/kpi/proj-kpi/get-my-proj-kpi-page', // 获取当前用户的项目绩效指标列表
            importProjKpis: apiPrefix + '/kpi/proj-kpi/import-proj-kpis', // 导入一体化系统项目绩效指标表到系统
            importSysProjKpis: apiPrefix + '/kpi/proj-kpi/import-sys-proj-kpis', // 导入系统标准绩效指标表到系统
            createProjKpiAiChat: apiPrefix + '/kpi/proj-kpi/create-proj-kpi-ai-chat', // 使用ai创建项目绩效目标表
            aiReasonerItems: apiPrefix + '/kpi/proj-kpi/ai-reasoner-items', // 使用ai推理分析项目绩效指标项
            saveReasonerItems: apiPrefix + '/kpi/proj-kpi/save-reasoner-items', // 保存ai推理的分析项目绩效指标项
            setMyProjKpiOrgId: apiPrefix + '/kpi/proj-kpi/set-my-proj-kpi-org-id', // 设置自己的指标表所属机构id
            getMyOrgProjKpiPage: apiPrefix + '/kpi/proj-kpi/get-my-org-proj-kpi-page', // 获取用户所属机构绩效表列表
            getMyOrgProjKpiDraftPage: apiPrefix + '/kpi/proj-kpi/get-my-org-proj-kpi-draft-page', // 获取用户所属机构草稿绩效表列表
        },
        myProjKpi: {
            draftSubmitToOrg: apiPrefix + '/kpi/my-proj-kpi/draft-submit-to-org',
            draftSubmitToOrgBatch: apiPrefix + '/kpi/my-proj-kpi/draft-submit-to-org-batch',
            getSubmitOrgProjKpiPage: apiPrefix + '/kpi/my-proj-kpi/get-submit-proj-kpi-page',
            removeSubmitProjKpi: apiPrefix + '/kpi/my-proj-kpi/remove-submit-proj-kpi',
        },
        projKpiAudit: {
            getDraftPage: apiPrefix + '/kpi/proj-kpi-audit/get-draft-page',
            getNoneAuditTaskPage: apiPrefix + '/kpi/proj-kpi-audit/get-none-audit-task-page',
            setAuditFlow: apiPrefix + '/kpi/proj-kpi-audit/set-audit-flow',
            setAuditFlowBatch: apiPrefix + '/kpi/proj-kpi-audit/set-audit-flow-batch',
            createAuditTask: apiPrefix + '/kpi/proj-kpi-audit/create-audit-task',
            createAuditTasks: apiPrefix + '/kpi/proj-kpi-audit/create-audit-tasks',
            getWaitingAuditProjOrgList: apiPrefix + '/kpi/proj-kpi-audit/get-waiting-audit-proj-org-list',
            getWaitingAuditPage: apiPrefix + '/kpi/proj-kpi-audit/get-waiting-audit-page',
            getAuditingPage: apiPrefix + '/kpi/proj-kpi-audit/get-auditing-page',
            getAuditedPage: apiPrefix + '/kpi/proj-kpi-audit/get-audited-page',
            getStorageId: apiPrefix + '/kpi/proj-kpi-audit/get-storage-id',
            flowRead: apiPrefix + '/kpi/proj-kpi-audit/flow-read',
            flowEdited: apiPrefix + '/kpi/proj-kpi-audit/flow-edited',
            flowAudited: apiPrefix + '/kpi/proj-kpi-audit/flow-audited',
            getAuditLevelNode: apiPrefix + '/kpi/proj-kpi-audit/get-audit-level-node',
            getAuditLogPage: apiPrefix + '/kpi/proj-kpi-audit/get-audit-log-page', // 项目绩效表审核日志
        },
        orgGroupConfig: {
            getKpiConfig: apiPrefix + '/kpi/org-group-config/get-kpi-config', // 获取被监管机构指标相关配置
            saveKpiConfig: apiPrefix + '/kpi/org-group-config/save-kpi-config', // 保存被监管机构默认的审核流程配置
        },
        projKpiItem: {
            save: apiPrefix + '/kpi/proj-kpi-item/save',
            getDetail: apiPrefix + '/kpi/proj-kpi-item/get-detail',
            remove: apiPrefix + '/kpi/proj-kpi-item/remove',
            getTable: apiPrefix + '/kpi/proj-kpi-item/get-table',
            getList: apiPrefix + '/kpi/proj-kpi-item/get-list',
            getTree: apiPrefix + '/kpi/proj-kpi-item/get-tree',
            excel: apiPrefix + '/kpi/proj-kpi-item/xls', // 导出项目指标到excel
            initItems: apiPrefix + '/kpi/proj-kpi-item/init-items', // 初始化项目绩效指标一二级指标项，会删除原有数据
        },
        auditFlowCfg: {
            myOrgSaveCfg: apiPrefix + '/kpi/audit-flow-cfg/my-org-save-cfg',
            myOrgRemoveCfg: apiPrefix + '/kpi/audit-flow-cfg/my-org-remove-cfg',
            myOrgGetCfgList: apiPrefix + '/kpi/audit-flow-cfg/my-org-get-cfg-list',
            myOrgGetCfgPage: apiPrefix + '/kpi/audit-flow-cfg/my-org-get-cfg-page',
            myOrgGetCfgDetail: apiPrefix + '/kpi/audit-flow-cfg/my-org-get-cfg-detail',
        },
        project: {
            save: apiPrefix + '/kpi/project/save',
            remove: apiPrefix + '/kpi/project/remove',
            getDetail: apiPrefix + '/kpi/project/get-detail',
            importProjects: apiPrefix + '/kpi/project/import-projects',
        },
        projMonitor: {
            getDraft: apiPrefix + '/kpi/proj-monitor/get-draft',
            create: apiPrefix + '/kpi/proj-monitor/create',
            save: apiPrefix + '/kpi/proj-monitor/save',
            remove: apiPrefix + '/kpi/proj-monitor/remove',
            getDetail: apiPrefix + '/kpi/proj-monitor/get-detail',
            fillPrevData: apiPrefix + '/kpi/proj-monitor/fill-prev-data',
            getList: apiPrefix + '/kpi/proj-monitor/get-list',
            getAnalysis: apiPrefix + '/kpi/proj-monitor/get-analysis',
            getMonths: apiPrefix + '/kpi/proj-monitor/get-months',
            getFirst: apiPrefix + '/kpi/proj-monitor/get-first',
            getLast: apiPrefix + '/kpi/proj-monitor/get-last',
            getSelfKpiPage: apiPrefix + '/kpi/proj-monitor/get-self-kpi-page',
            cleanProjMonitor: apiPrefix + '/kpi/proj-monitor/clear-proj-monitor', // 清空项目绩效表的监控表数据
            excel: apiPrefix + '/kpi/proj-monitor/xls', // 导出项目目标监控到excel
            buildZip: apiPrefix + '/kpi/proj-monitor/build-zip', // 生成项目绩效表的监控表压缩包
        },
        projAppraise: {
            getMyPage: apiPrefix + '/kpi/proj-appraise/get-my-page', // 获取当前用户的项目绩效指标自评列表
            getId: apiPrefix + '/kpi/proj-appraise/get-id', // 生成或获取项绩效表自评表id
            getTable: apiPrefix + '/kpi/proj-appraise/get-table',
            save: apiPrefix + '/kpi/proj-appraise/save',
            saveWeights: apiPrefix + '/kpi/proj-appraise/save-weights',
            remove: apiPrefix + '/kpi/proj-appraise/remove',
            calcScore: apiPrefix + '/kpi/proj-appraise/calc-score',
            createProjAppraiseAISession: apiPrefix + '/kpi/proj-appraise/create-proj-appraise-ai-session', // 创建自评报告AI会话
            uploadProjAppraiseAttachmentPrefix: apiPrefix + '/kpi/proj-appraise/upload-proj-appraise-attachment', // 上传附件到自评报告AI会话api路径前级
            deleteProjAppraiseAttachment: apiPrefix + '/kpi/proj-appraise/delete-proj-appraise-attachment', // 删除自评报告AI会话附件
            createProjKpiAppraiseReportAIChat: apiPrefix + '/kpi/proj-appraise/create-proj-kpi-appraise-report-ai-chat', // 使用ai生成项目支出自评报告
            xls: apiPrefix + '/kpi/proj-appraise/xls', // 导出项目绩效表自评表到excel
        },
        auditFLow: {
            getList: apiPrefix + '/kpi/audit-flow/get-list', // 获取审核流程列表
            getDetail: apiPrefix + '/kpi/audit-flow/get-detail', // 获取审核流程详情
            save: apiPrefix + '/kpi/audit-flow/save', // 保存审核流程
        },
    },
    // 流量采集统计相关接口
    statCounter: {
        statApp: {
            createAppKey: apiPrefix + '/stat-counter/stat-app/create-app-key',
            saveApp: apiPrefix + '/stat-counter/stat-app/save',
            remove: apiPrefix + '/stat-counter/stat-app/remove',
            getDetail: apiPrefix + '/stat-counter/stat-app/get-detail',
            getPage: apiPrefix + '/stat-counter/stat-app/get-page',
        },
        stat: {
            appVisitCount: apiPrefix + '/stat-counter/stat/app-visit-count',
            browserVisitCount: apiPrefix + '/stat-counter/stat/browser-visit-count',
            deviceVisitCount: apiPrefix + '/stat-counter/stat/device-visit-count',
            ipVisitCount: apiPrefix + '/stat-counter/stat/ip-visit-count',
            pageVisitCount: apiPrefix + '/stat-counter/stat/page-visit-count',
            topicVisitCount: apiPrefix + '/stat-counter/stat/topic-visit-count',
            articleVisitCount: apiPrefix + '/stat-counter/stat/article-visit-count',
            getVisitorPage: apiPrefix + '/stat-counter/stat/get-visitor-page', // 获取访客列表
        },
        access: {
            visitPoint: apiPrefix + '/stat-counter/access/visit-point.js',
        },
    },
    das: {
        dynamicTable: {
            saveFormConfig: apiPrefix + '/das/dynamic-table/save-form-config', // 保存用户自定义表单
        },
        project: {
            save: apiPrefix + '/das/project/save',
            remove: apiPrefix + '/das/project/remove',
            getDetail: apiPrefix + '/das/project/get-detail',
            getInfo: apiPrefix + '/das/project/get-info',
            getPage: apiPrefix + '/das/project/get-page',
            getList: apiPrefix + '/das/project/get-list',
            getFormFields: apiPrefix + '/das/project/get-form-fields', // 获取项目表单字段列表
            getFormConfig: apiPrefix + '/das/project/get-form-config', // 获取项目表单配置
            share: apiPrefix + '/das/project/share', // 分享项目表单
        },
        projectItem: {
            save: apiPrefix + '/das/project-item/save',
            remove: apiPrefix + '/das/project-item/remove',
            getDetail: apiPrefix + '/das/project-item/get-detail',
            getPage: apiPrefix + '/das/project-item/get-page',
        },
        projectShare: {
            login: apiPrefix + '/das/project-share/login', // 分享用户登录
            saveProjectItem: apiPrefix + '/das/project-share/save-project-item', // 分享用户保存表单数据
            getFormFields: apiPrefix + '/das/project-share/get-form-fields', // 获取项目表单字段列表
            getFormConfig: apiPrefix + '/das/project-share/get-form-config', // 获取项目表单配置
            getProjItemDetail: apiPrefix + '/das/project-share/get-proj-item-detail', //
        },
        menu: {
            save: apiPrefix + '/das/menu/save', // 保存用户菜单项
            remove: apiPrefix + '/das/menu/remove', // 删除用户菜单项
            getDetail: apiPrefix + '/das/menu/get-detail', // 删除用户菜单项
            getList: apiPrefix + '/das/menu/get-list', // 获取用户所有菜单项列表
        },
        utable: {
            getDetail: apiPrefix + '/das/u-table/get-detail',
            save: apiPrefix + '/das/u-table/save',
            delete: apiPrefix + '/das/u-table/delete',
            getMyTables: apiPrefix + '/das/u-table/get-my-tables',
            getMyTablesPage: apiPrefix + '/das/u-table/get-my-tables-page',
            getFieldDetail: apiPrefix + '/das/u-table/get-field-detail',
            deleteField: apiPrefix + '/das/u-table/delete-field',
            saveField: apiPrefix + '/das/u-table/save-field',
            getTableFields: apiPrefix + '/das/u-table/get-table-fields',
            getSetting: apiPrefix + '/das/u-table/get-setting',
            saveSetting: apiPrefix + '/das/u-table/save-setting',
        },
        utableData: {
            save: apiPrefix + '/das/u-table-data/save', // 保存数据
            getPage: apiPrefix + '/das/u-table-data/get-page', // 分页获取数据列表
            getDetail: apiPrefix + '/das/u-table-data/get-detail',
            remove: apiPrefix + '/das/u-table-data/remove',
            getList: apiPrefix + '/das/u-table-data/get-list',
            getAllList: apiPrefix + '/das/u-table-data/get-all-list',
            importData: apiPrefix + '/das/u-table-data/import-data',
            shareTableReport: apiPrefix + '/das/u-table-data/share-table-report',
            shareTableForm: apiPrefix + '/das/u-table-data/share-table-form',
        },
        utableShare: {
            shareOption: apiPrefix + '/das/u-table-share/share-option',
            getShareTableData: apiPrefix + '/das/u-table-share/get-share-table-data',
            getShareTableForm: apiPrefix + '/das/u-table-share/get-share-table-form',
            saveFormData: apiPrefix + '/das/u-table-share/save-form-data', // 保存报送的表单数据
        },
    },
};
